import request from '@/utils/request'

// Activations that report themselves complete while the cane is not bound to
// that user in `devices`. That combination is what silently costs an owner the
// hardware's permanent features, so it is worth a screen of its own.
export const getFailedActivations = (params: { limit?: number, offset?: number, search?: string }) =>
  request({
    url: '/cane-activation/failed-activations',
    method: 'get',
    params
  })

// Admin repair for a row of the list above: bind the cane to the user it was
// activated by and push the device's features to that user. Only for canes
// that are unowned or missing; a cane owned by someone else is not touched.
export const bindFailedActivation = (data: { serialNumber: string, userId: string, version?: string | null }) =>
  request({
    url: '/cane-activation/failed-activations/bind',
    method: 'post',
    data
  })
